<h3>{{ 'orders.serialCollateral' | transloco }}</h3>
<!-- Assets -->
@if (uiConfiguration) {
  <div class="flex-container no-margin">
    <lib-asset-list
      [order]="order"
      [observableAssets$]="assets$"
      [errors$]="errors$"
      [uiConfiguration]="uiConfiguration"
      class="flex-item"
      [isEditable]="isEditable"
      [expandedAsset]="expandedAsset"
      (assetAddedEvent)="handleAssetAddedEvent($event)"
      (assetsUploadedEvent)="handleAssetsUploadedEvent($event)"
      (allAssetsRemovedEvent)="handleAllAssetsRemovedEvent()"
      (assetUpdatedEvent)="handleAssetSaveEvent($event)"
      (assetCopiedEvent)="handleAssetCopiedEvent($event)"
      (assetRemovedEvent)="handleAssetRemovedEvent($event)"
      (assetFormValueChangedEvent)="handleAssetFormValueChange($event)"
      (assetSearchRequestedEvent)="handleAssetSearchRequestedEvent($event)">
    </lib-asset-list>
  </div>
}